import {
  CreateChargeStripeAPIInput,
  CreateChargeStripeAPIMutationVariables,
  CreateRefundStripeAPIMutationVariables,
  CreateStripeChargeInput,
  CreateStripeChargeMutationVariables,
  CreateStripeSubscriptionAPIMutationVariables,
  CreateStripeSubscriptionInput,
  CreateStripeSubscriptionMutationVariables,
  ListStripeChargesByPollQueryVariables,
  ListStripeSubscriptionByUserQueryVariables,
  ModelSortDirection,
  ModelStripeChargeFilterInput,
  StripeChargeStatus,
  UpdateStripeChargeMutationVariables,
  AddPremiumPollCountInput,
  AddPremiumPollCountMutationVariables,
  CanCreatePremiumPollMutationVariables,
  CanCreatePremiumPollInput,
  Currency,
  CreateIdeaPledgeStripeChargeInput,
  CreateIdeaPledgeStripeChargeMutationVariables,
  ListIdeaPledgeStripeChargesByIdeaPledgeQueryVariables,
  CreateIdeaPledgeStripeChargeAPIMutationVariables,
  CreateIdeaPledgeStripeChargeAPIInput,
  ListIdeaPledgeStripeChargesByIdeaQueryVariables
} from "../API";
import API from "@aws-amplify/api";
import { buildVariables } from "../libs/GraphQueryBuilder";
import { mutation, query } from "gql-query-builder";
import { getPollDetail } from "./PollsManager";
import { pledgePoll } from "./PledgesManager";

export function getStripeSubscriptionByUser(userID) {
  const _variables: ListStripeSubscriptionByUserQueryVariables = {
    userID,
    sortDirection: ModelSortDirection.DESC,
  };
  const variables = buildVariables<ListStripeSubscriptionByUserQueryVariables>(
    _variables,
    [{ key: "sortDirection", name: "ModelSortDirection" }]
  );
  const q = query({
    operation: "result: listStripeSubscriptionByUser",
    fields: [
      { items: ["customerID", "tier", "subscriptionID", "owner", "createdAt"] },
    ],
    variables,
  });
  return API.graphql(q);
}
function createStripeSubscription(input: CreateStripeSubscriptionInput) {
  console.log(JSON.stringify(input));
  const _variables: CreateStripeSubscriptionMutationVariables = {
    input,
  };
  const variables = buildVariables<CreateStripeSubscriptionMutationVariables>(
    _variables,
    [{ key: "input", name: "CreateStripeSubscriptionInput!" }]
  );
  const q = mutation({
    operation: "result: createStripeSubscription",
    fields: ["id"],
    variables,
  });
  return API.graphql(q);
}

function getPriceIDByTier(tier) {
  return "";
}

export async function createSubscription(userID, tier, stripeToken, coupon) {
  const _variables: CreateStripeSubscriptionAPIMutationVariables = {
    input: {
      userID,
      tier,
      token: stripeToken,
      coupon,
    },
  };
  const variables =
    buildVariables<CreateStripeSubscriptionAPIMutationVariables>(_variables, [
      { key: "input", name: "CreateStripeSubscriptionAPIInput!" },
    ]);
  const q = mutation({
    operation: "result: createStripeSubscriptionAPI",
    fields: [],
    variables,
  });

  const stripeSub: any = await API.graphql(q);
  const response = JSON.parse(stripeSub.data.result);
  console.log(response);
  if (response.statusCode !== 200) {
    throw new Error(response.message);
  }
  const { subscriptionID, customerID } = response.body;
  const stripeSubInput: CreateStripeSubscriptionInput = {
    subscriptionID,
    customerID,
    tier,
    userID,
  };
  await createStripeSubscription(stripeSubInput);
  return Promise.resolve({
    subscriptionID,
    customerID,
    tier,
    userID,
  });
}
export async function listStripeChargesByPoll(pollID) {
  const _variables: ListStripeChargesByPollQueryVariables = {
    pollID,
    filter: {
      status: { eq: StripeChargeStatus.PAID },
    },
  };
  const variables = buildVariables<ListStripeChargesByPollQueryVariables>(
    _variables,
    [
      { key: "status", name: "StripeChargeStatus" },
      { key: "filter", name: "ModelStripeChargeFilterInput" },
    ]
  );
  const q = query({
    operation: "result: listStripeChargesByPoll",
    fields: [
      { items: ["id", "userID", "pollID", "chargeID", "status", "amount"] },
    ],
    variables,
  });
  const charges: any = await API.graphql(q);
  return Promise.resolve(charges.data.result.items);
}

function getTierPercentByOwner(pollOwner) {
  return 1.5;
}
export async function reportCancelPollCharge(pollID) {
  const charges = await listStripeChargesByPoll(pollID);
  const poll = await getPollDetail(["owner"], pollID);
  const tierPercent = await getTierPercentByOwner(poll.data.result.owner);
  const sumAmount = charges
    .map((charge) => parseInt(charge.amount))
    .reduce((sum, curr) => sum + curr, 0);
  const total = sumAmount * 1.1 + sumAmount * tierPercent;
  return Promise.resolve({ pollID, total });
}

async function refundCharge(id, chargeID, includeFee) {
  const _variables: CreateRefundStripeAPIMutationVariables = {
    input: {
      chargeID,
      includeFee,
    },
  };
  const variables = buildVariables<CreateRefundStripeAPIMutationVariables>(
    _variables,
    [{ key: "input", name: "CreateRefundStripeAPIInput!" }]
  );
  const q = mutation({
    operation: "result: createRefundStripeAPI",
    fields: [],
    variables,
  });
  await API.graphql(q);
  return updateStripeChargeStatus(id, StripeChargeStatus.REFUNDED);
}

export async function refundCancelPollCharge(pollID) {
  const charges = await listStripeChargesByPoll(pollID);
  const promises: any = [];
  charges.forEach((charge) => {
    const { id, chargeID, status } = charge;
    if (status === "PAID") {
      promises.push(refundCharge(id, chargeID, true));
    }
  });
  return Promise.all(promises);
}

async function getStripeChargeByPledge(pollID, userID) {
  const _variables: ListStripeChargesByPollQueryVariables = {
    pollID,
    filter: {
      userID: { eq: userID },
    },
  };
  const variables = buildVariables<ListStripeChargesByPollQueryVariables>(
    _variables,
    [{ key: "filter", name: "ModelStripeChargeFilterInput" }]
  );
  const q = query({
    operation: "result: listStripeChargesByPoll",
    fields: [
      { items: ["id", "userID", "pollID", "chargeID", "status", "amount"] },
    ],
    variables,
  });
  const charges: any = await API.graphql(q);
  if (charges.data?.result?.items.length === 0) {
    return undefined;
  } else {
    return charges.data?.result?.items[0];
  }
}

function updateStripeChargeStatus(id, status) {
  const _variables: UpdateStripeChargeMutationVariables = {
    input: {
      id,
      status,
    },
  };
  const variables = buildVariables<UpdateStripeChargeMutationVariables>(
    _variables,
    [{ key: "input", name: "UpdateStripeChargeInput!" }]
  );
  const q = mutation({
    operation: "result: updateStripeCharge",
    fields: ["id"],
    variables,
  });
  return API.graphql(q);
}

export async function refundPledgeCharge(userID, pollID) {
  const charge = await getStripeChargeByPledge(pollID, userID);
  console.log(`charge ${JSON.stringify(charge)}`);
  if (charge === undefined) {
    throw new Error("Charge does not exist");
  }
  const { id, chargeID, status } = charge;
  if (status !== "PAID") {
    throw new Error(`charge is ${status}`);
  }
  await refundCharge(id, chargeID, false);
  return Promise.resolve({ success: true });
}

function createStripeCharge(input: CreateStripeChargeInput) {
  const _variables: CreateStripeChargeMutationVariables = {
    input,
  };
  const variables = buildVariables<CreateStripeChargeMutationVariables>(
    _variables,
    [{ key: "input", name: "CreateStripeChargeInput!" }]
  );
  const q = mutation({
    operation: "result: createStripeCharge",
    fields: ["id"],
    variables,
  });
  return API.graphql(q);
}

function createIdeaPledgeStripeCharge(input: CreateIdeaPledgeStripeChargeInput) {
  const _variables: CreateIdeaPledgeStripeChargeMutationVariables = {
    input,
  };
  const variables = buildVariables<CreateIdeaPledgeStripeChargeMutationVariables>(
      _variables,
      [{ key: "input", name: "CreateIdeaPledgeStripeChargeInput!" }]
  );
  const q = mutation({
    operation: "result: createIdeaPledgeStripeCharge",
    fields: ["id"],
    variables,
  });
  return API.graphql(q);
}

async function createStripeChargeAPI(input: CreateChargeStripeAPIInput) {
  const _variables: CreateChargeStripeAPIMutationVariables = {
    input,
  };
  const variables = buildVariables<CreateChargeStripeAPIMutationVariables>(
    _variables,
    [{ key: "input", name: "CreateChargeStripeAPIInput!" }]
  );
  const chargeOps = mutation({
    operation: "result: createChargeStripeAPI",
    fields: [],
    variables,
  });
  const charge: any = await API.graphql(chargeOps);
  const chargeResult = JSON.parse(charge.data.result);
  return Promise.resolve(chargeResult?.body);
}

export async function chargePledge(
  userID: string,
  pollID: string,
  stripeToken: string,
  coupon?: string
) {
  const poll: any = await getPollDetail(
    [
      "status",
      { options: ["id", { detail: ["price", "currency"] }] },
      { voteResults: [{ items: ["id", "count"] }] },
    ],
    pollID
  );
  const { options, voteResults } = poll.data.result;
  let winID = voteResults.items[voteResults.items.length - 1].id.split(".")[1];
  const winOption = options[winID];
  const { price, currency } = winOption?.detail;
  if (price === undefined || currency === undefined) {
    throw new Error("missing price and currency");
  }
  let charge: any = undefined;
  charge = await getStripeChargeByPledge(pollID, userID);

  if (charge) {
    throw new Error("Charge already exists");
  } else {
    charge = await createStripeChargeAPI({
      price,
      currency: currency || Currency.SGD,
      token: stripeToken,
      userID,
      coupon,
    });
    const chargeID = charge.id;
    const amount = parseInt(price) * 100;
    chargeID &&
      (await createStripeCharge({
        userID,
        pollID,
        chargeID,
        amount: amount.toString(),
        status: StripeChargeStatus.PAID,
      }));
    await pledgePoll(pollID, userID);

    return charge;
  }
}

export function addPremiumPollCount(
  fields: any[],
  token: string,
  coupon?: string
) {
  const variables = buildVariables<AddPremiumPollCountMutationVariables>(
    {
      input: {
        token,
        coupon,
      },
    },
    [
      { key: "input", name: "AddPremiumPollCountInput!" },
      //   { key: "condition", name: "ModelPollConditionInput" },
    ]
  );
  console.log(variables);

  return API.graphql(
    mutation({
      operation: "result: addPremiumPollCount",
      fields,
      variables,
    })
  );
}

export async function chargePremiumPoll(stripeToken: string, coupon = "") {
  const res = (await addPremiumPollCount([], stripeToken, coupon)) as any;
  return res.data?.result;
}


async function createIdeaPledgeStripeChargeAPI(input: CreateIdeaPledgeStripeChargeAPIInput) {
  const _variables: CreateIdeaPledgeStripeChargeAPIMutationVariables = {
    input,
  };
  const variables = buildVariables<CreateIdeaPledgeStripeChargeAPIMutationVariables>(
      _variables,
      [{ key: "input", name: "CreateIdeaPledgeStripeChargeAPIInput!" }]
  );
  const chargeOps = mutation({
    operation: "result: createIdeaPledgeStripeChargeAPI",
    fields: [],
    variables,
  });
  const charge: any = await API.graphql(chargeOps);
  const chargeResult = JSON.parse(charge.data.result);
  return Promise.resolve(chargeResult?.body);
}
export async function getIdeaPledgeStripeChargeById(id) {
  const _variables: ListIdeaPledgeStripeChargesByIdeaQueryVariables = {
      ideaID: id
  };
  const variables = buildVariables<ListIdeaPledgeStripeChargesByIdeaQueryVariables>(
      _variables,
      [{ key: "filter", name: "ModelIdeaPledgeStripeChargeFilterInput" }]
  );
  const q = query({
    operation: "result: listIdeaPledgeStripeChargesByIdea",
    fields: [
      { items: ["id", "ideaID", "userID", "ideaPledgeID", "chargeID", "status", "amount",{user:['username','email','phone']}] },
    ],
    variables,
  });

  const charges: any = await API.graphql(q);
  return charges.data?.result?.items
}
export async function getIdeaPledgeStripeChargeByUser(ideaPledgeID, userID) {

  const _variables: ListIdeaPledgeStripeChargesByIdeaPledgeQueryVariables = {
    ideaPledgeID,
    filter: {
      userID: { eq: userID },
    },
  };
  const variables = buildVariables<ListIdeaPledgeStripeChargesByIdeaPledgeQueryVariables>(
      _variables,
      [{ key: "filter", name: "ModelIdeaPledgeStripeChargeFilterInput" }]
  );
  const q = query({
    operation: "result: listIdeaPledgeStripeChargesByIdeaPledge",
    fields: [
      { items: ["id", "ideaID", "userID", "ideaPledgeID", "chargeID", "status", "amount"] },
    ],
    variables,
  });
  const charges: any = await API.graphql(q);
  if (charges.data?.result?.items.length === 0) {
    return undefined;
  } else {
    return charges.data?.result?.items[0];
  }
}



export async function chargeIdeaPledge(
    userID: string,
    ideaID: string,
    ideaPledgeID: string,
    stripeToken: string,
    price: number,
    currency?: string,
    coupon?: string
) {
  let charge: any = undefined;
  charge = await getIdeaPledgeStripeChargeByUser(ideaPledgeID, userID);

  if (charge) {
    throw new Error("Charge already exists");
  } else {
    charge = await createIdeaPledgeStripeChargeAPI({
      ideaID,
      ideaPledgeID,
      price,
      currency: currency || Currency.SGD,
      token: stripeToken,
      userID,
      coupon
    });
    const chargeID = charge.id;
    const amount = price * 100;
    chargeID &&
    (await createIdeaPledgeStripeCharge({
      userID,
      ideaID,
      ideaPledgeID,
      chargeID,
      amount: amount.toString(),
      status: StripeChargeStatus.PAID,
    }));

    return charge;
  }
}
